export const hosturl ="https://api.raoosastro.com"